import { PaletteUtils } from '@shared/utils';
import { Button, Icon, Text } from '@shared/widgets';
import CopyIcon from '@assets/icons/copy.svg';

interface ItemProps {
  name: string;
  value: string;
}

export const Item = (props: ItemProps) => {
  return (
    <div className='my-3 flex items-center justify-between first:my-0'>
      <div>
        <Text size='sm' color='secondary'>
          {props.name}
        </Text>
        <Text className='max-w-52 break-words pr-3' weight='semibold' size='sm'>
          {props.value}
        </Text>
      </div>
      <div className='flex items-center gap-2'>
        <Button color='icon' onClick={() => navigator.clipboard.writeText(props.value)}>
          <Icon color={PaletteUtils.isInsigniaPalette ? 'primary' : undefined} icon={<CopyIcon />} />
        </Button>
      </div>
    </div>
  );
};
